<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone>
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="9" style="text-align: center">销售收入结算情况</b-th>
          <b-th colspan="5" style="text-align: center">折合合同约定币种销售情况</b-th>
          <b-th colspan="4" style="text-align: center">折合人民币销售情况</b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <!--      <template v-slot:cell(contractorName)="data">-->
      <!--        <div style="color: #4caedc" @click="showDetail(data.item.contractorName)">{{ data.item.contractorName }}</div>-->
      <!--      </template>-->
      <!--      <template v-slot:cell(joinDate)="data">-->
      <!--        {{moment(data.item.joinDate).format("YYYY-MM-DD")}}-->
      <!--      </template>-->
      <!--      <template v-slot:cell(leaveDate)="data">-->
      <!--        {{-->
      <!--          (data.item.leaveDate === '' || data.item.leaveDate === undefined) ? '-' : moment(data.item.leaveDate).format("YYYY-MM-DD")-->
      <!--        }}-->
      <!--      </template>-->
      <template v-slot:cell(unitPrice)="data">
        {{ Number(data.item.unitPrice).toFixed(2) }}
      </template>
      <template v-slot:cell(actUnitPrice)="data">
        {{ Number(data.item.actUnitPrice || 0).toFixed(2) }}
      </template>
      <template v-slot:cell(amount)="data">
        {{ Number(data.item.amount).toFixed(2) }}
      </template>
      <template v-slot:cell(rateContract)="data">
        {{ Number(data.item.rateContract).toFixed(6) }}
      </template>
      <template v-slot:cell(unitPriceContract)="data">
        {{ Number(data.item.unitPriceContract).toFixed(2) }}
      </template>
      <template v-slot:cell(actUnitPriceContract)="data">
        {{ Number(data.item.actUnitPriceContract).toFixed(2) }}
      </template>
      <template v-slot:cell(amountContract)="data">
        {{ Number(data.item.amountContract).toFixed(2) }}
      </template>
      <template v-slot:cell(rateCny)="data">
        {{ Number(data.item.rateCny).toFixed(6) }}
      </template>
      <template v-slot:cell(unitPriceCny)="data">
        {{ Number(data.item.unitPriceCny).toFixed(2) }}
      </template>
      <template v-slot:cell(actUnitPriceCny)="data">
        {{ Number(data.item.actUnitPriceCny).toFixed(2) }}
      </template>
      <template v-slot:cell(amountCny)="data">
        {{ Number(data.item.amountCny).toFixed(2) }}
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}"></div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
      </template>
      <template v-slot:foot(amount)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'amount') }}</div>
      </template>
      <template v-slot:foot(amountContract)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'amountContract') }}</div>
      </template>
      <template v-slot:foot(amountCny)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'amountCny') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "ItsSalesOuterSalesDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'no', label: '销售件数（筐）', width: '120px'},
        {key: 'address',  label: '销售地点', width: '120px'},
        {key: 'typeLabel',  label: '销售方式', width: '120px'},
        {key: 'modelLabel', label: '计价模式', width: '120px'},
        {key: 'currencyName', label: '币种', width: '100px'},
        {key: 'unitPrice', label: '销售单价', width: '120px'},
        {key: 'actUnitPrice', label: '实际销售单价', width: '120px'},
        {key: 'amount', label: '销售金额（元）', width: '120px'},
        {key: 'payTypeLabel', label: '收款方式', width: '120px'},
        {key: 'currencyContractName', label: '币种', width: '100px'},
        {key: 'rateContract', label: '汇率', width: '100px'},
        {key: 'unitPriceContract', label: '销售单价（元/斤）', width: '120px'},
        {key: 'actUnitPriceContract', label: '实际销售单价（元/斤）', width: '140px'},
        {key: 'amountContract', label: '金额（元）', width: '120px'},
        {key: 'rateCny', label: '汇率', width: '100px'},
        {key: 'unitPriceCny', label: '单价（元/斤）', width: '120px'},
        {key: 'actUnitPriceCny', label: '实际销售单价（元/斤）', width: '120px'},
        {key: 'amountCny', label: '金额（元）', width: '120px'},
      ],
      items: [],
      unitCategory: '',
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key, n = 2) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(n, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>